import { Component, OnInit } from '@angular/core';
import { FormsService } from "../../providers/forms.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FirebaseService } from "../../providers/firebase.service";
import { Client } from "../../models/client";
import { AWSConnectorService } from '../../providers/aws-connector';
import { LocationInfo } from '../../models/locationInfo';
import * as _ from 'lodash';
import 'rxjs/add/operator/first';

@Component({
  selector: 'app-location-checkout-charges',
  templateUrl: './location-checkout-charges.component.html',
  styleUrls: ['./location-checkout-charges.component.scss']
})
export class LocationCheckoutChargesComponent implements OnInit {
  key: string;
  locKey: string;
  filterText: string;
  chargesData;
  filteredData;
  clientData: Client;
  locationData: LocationInfo;

  constructor(
    public forms: FormsService,
    private router: Router,
    public route: ActivatedRoute,
    public afService: FirebaseService,
    private awsConn: AWSConnectorService,
  ) { }

  async ngOnInit() {
    await this._getParams();
    this.clientData = await this._getClient();
    this.locationData = await this._getLocation();
  }

  addCharge(charge) {
    if (!_.isArray(this.locationData.checkoutCharges)) {
      this.locationData.checkoutCharges = [charge];
    }
    else if (_.findIndex(this.locationData.checkoutCharges, ['ChargeDescID', charge.ChargeDescID]) < 0) {
      this.locationData.checkoutCharges.push(charge);
    }
    this.save();
    this.filter();
  }

  removeCharge(charge) {
    this.locationData.checkoutCharges.splice(_.findIndex(this.locationData.checkoutCharges, ['ChargeDescID', charge.ChargeDescID]), 1);
    this.save();
    this.filter();
  }

  saveChargeToggle(e) {
    this.locationData.payForCheckoutCharges = e.checked;
    this.save();
  }

  saveExcludeToggle(e) {
    this.locationData.checkoutChargesExcludeParkingAndOffice = e.checked;
    this.save();
  }

  save() {
    this.afService.updateLocation(this.clientData, {
      checkoutCharges: this.locationData.checkoutCharges || null,
      payForCheckoutCharges: this.locationData.payForCheckoutCharges || false,
      checkoutChargesExcludeParkingAndOffice: this.locationData.checkoutChargesExcludeParkingAndOffice || false
    }, this.locationData.$key).then(() => {
      this.afService.openSnackBar('Location Saved Successfully.');
    }).catch(e => {
      this.afService.openSnackBar('ERROR saving Location.');
    });
  }

  filter() {
    this.filteredData = _.filter(this.chargesData, c => {
      if (_.findIndex(this.locationData.checkoutCharges, ['ChargeDescID', c.ChargeDescID]) > -1) {
        return false;
      }
      else if (this.filterText) {
        return c.sChgDesc.toLowerCase().includes(this.filterText.toLocaleLowerCase());
      }
      else {
        return true;
      }
    });
  }

  loadPosItemData() {
    const sub = this.awsConn.getAllPosItems(this.clientData.code, this.locKey).first()
      .subscribe(data => {
        sub.unsubscribe();
        console.log(data);
        if (_.isArray(data)) {
          this.chargesData = data;
        }
        else {
          this.chargesData = [data];
        }
        this.filter();
      });
  }

  private _getParams(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.route.params.first()
        .subscribe(params => {
          this.key = params['key'];
          this.locKey = params['locKey'];
          resolve();
        }, error => reject(error));
    });
  }

  private _getClient(): Promise<Client> {
    return new Promise((resolve, reject) => {
      this.afService.getClientInfo(this.key).first()
        .subscribe((data: Client) => resolve(data), error => reject(error));
    });
  }

  private _getLocation(): Promise<LocationInfo> {
    return new Promise((resolve, reject) => {
      this.afService.getLocationInfo(this.key, this.locKey).first()
        .subscribe((data: LocationInfo) => resolve(data), error => reject(error));
    });
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/location-checkout-charges/location-checkout-charges.component.ts